import { useEffect } from "react";

// for cometchat errors

const isAutoplayBlockedMediaError = (errLike, fallbackMessage = "") => {
	const name = String(errLike?.name || "");
	const message = String(errLike?.message || fallbackMessage || "").toLowerCase();
	const stack = String(errLike?.stack || "").toLowerCase();

	return (
		name === "NotAllowedError" &&
		(message.includes("play") ||
			message.includes("user agent") ||
			message.includes("denied permission") ||
			stack.includes("play@native code"))
	);
};

export function useMediaAutoplayGuard() {
	useEffect(() => {
		if (typeof window === "undefined") return;

		const ua = navigator.userAgent || "";
		const isIOS = /iPhone|iPad|iPod/i.test(ua);
		if (!isIOS) return;

		const proto = window.HTMLMediaElement?.prototype;
		if (!proto) return;

		const originalPlay = proto.play;
		if (typeof originalPlay !== "function") return;

		if (!proto.__onBiblePlayPatched) {
			// iOS may reject autoplay in background/non-gesture contexts.
			proto.play = async function onBibleSafePlay(...args) {
				try {
					return await originalPlay.apply(this, args);
				} catch (err) {
					if (isAutoplayBlockedMediaError(err)) return undefined;
					throw err;
				}
			};

			proto.__onBiblePlayPatched = true;
		}

		const onUnhandledRejection = event => {
			if (isAutoplayBlockedMediaError(event?.reason)) {
				event.preventDefault?.();
			}
		};

		const onWindowError = event => {
			if (isAutoplayBlockedMediaError(event?.error, event?.message)) {
				event.preventDefault?.();
			}
		};

		window.addEventListener("unhandledrejection", onUnhandledRejection);
		window.addEventListener("error", onWindowError);

		return () => {
			window.removeEventListener("unhandledrejection", onUnhandledRejection);
			window.removeEventListener("error", onWindowError);
		};
	}, []);
}
